/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import { Col, Row } from 'reactstrap';
import { FieldArray } from 'redux-form';
import {
  BUILDING_ASPECT_RATIO,
  BUILDING_SQUARE_FOOTAGE,
  FLOOR_PLAN_BY_STORY,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import FieldVisibilityToggle from '#components/pages/Models/Model/sections/support/forms/FieldVisibilityToggle/index.js';
import { Field, Fieldset } from '#components/pages/Models/Model/support/form/index.js';
import renderFloorPlanByStory from '#components/pages/Models/Model/sections/shared/BuildingLayoutSection/FloorPlanFieldset/renderFloorPlanByStory/index.jsx';

type Props = {|
  afterToggleOn: Function,
  defineByStory: boolean,
  form: string,
  supportDefineByStory: boolean,
|};

const FloorPlanFieldset = ({
  afterToggleOn,
  defineByStory,
  form,
  supportDefineByStory,
}: Props): Element<typeof Fieldset> => {
  const { fieldsByName } = modelTypesByForm[form];
  return (
    <Fieldset>
      <legend>Floor Plan</legend>
      <Row>
        {supportDefineByStory && (
          <Col>
            <FieldVisibilityToggle
              afterToggleOn={afterToggleOn}
              className="float-right define-floor-plan-toggle"
              form={form}
              on={defineByStory}
              onFields={[FLOOR_PLAN_BY_STORY]}
              onText="Use simplified"
              offFields={[BUILDING_SQUARE_FOOTAGE, BUILDING_ASPECT_RATIO]}
              offText="Define by story"
            />
          </Col>
        )}
      </Row>
      {defineByStory ? (
        <FieldArray
          form={form}
          name={FLOOR_PLAN_BY_STORY}
          component={renderFloorPlanByStory}
          fieldsByName={fieldsByName}
        />
      ) : (
        <>
          <Row>
            <Col lg="6">
              <Field field={fieldsByName[BUILDING_SQUARE_FOOTAGE]} />
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <Field field={fieldsByName[BUILDING_ASPECT_RATIO]} />
            </Col>
          </Row>
        </>
      )}
    </Fieldset>
  );
};

export default FloorPlanFieldset;
